import { useEffect, useReducer, useState } from "react";
import { Trans } from "react-i18next";
import { Heading } from "../../../ui/components/Heading";
import { ChatbotCtrls } from "../../components/ChatbotCtrls";
import { useAdminSelector } from "../../../../stores/AdminStore";
import { ChatbotMainContent } from "../../components/ChatbotMainContent";
import { ChatbotLayoutContainer } from "../../components/ChatbotLayoutContainer";
import { ChatbotConversationNavigator } from "../../components/ChatbotConversationNavigator";
import chatbotStateReducer, { initialChatBotState } from "../../utils/chatbotStateReducer";
import { ChatbotStateContext, ChatbotStateDispatchContext } from "../../utils/chatbotContext";
import { PermissionGuard } from "../../../core/components/PermissionGuard";
import { UserPermissions } from "../../../core/models/UserPermissions";


export const Chatbot = () => {
  // User
  const { initials } = useAdminSelector(s => s.auth);
  // UI Nav
  const [isNavVisible, setIsNavVisible] = useState<boolean>(false);
  // Chatbot State
  const [chatbotState, dispatch] = useReducer(chatbotStateReducer, initialChatBotState);

  useEffect(() => {
    if (chatbotState.currentState !== "Connected State") {
      setIsNavVisible(false);
    } else {
      setIsNavVisible(true);
    }
  }, [chatbotState.currentState]);

  return (
    <>
      <PermissionGuard permissions={[UserPermissions.Wingman]}>
        <Heading><Trans>Wingman</Trans></Heading>
        <ChatbotStateContext.Provider value={chatbotState}>
          <ChatbotStateDispatchContext.Provider value={dispatch}>
            <ChatbotCtrls>
              <ChatbotLayoutContainer
                isNavVisible={isNavVisible}
                sideContent={<ChatbotConversationNavigator />}
                mainContent={<ChatbotMainContent
                  initials={initials}
                  isNavVisible={isNavVisible}
                  setIsNavVisible={setIsNavVisible}
                />} />
            </ChatbotCtrls>
          </ChatbotStateDispatchContext.Provider>
        </ChatbotStateContext.Provider>
      </PermissionGuard>
    </>
  );
};